import { useToast } from '@chakra-ui/react';
import { useUser } from '@clerk/react';
import { ToastPosition, useStatusToast } from '@this+that/ui';

export const useCustomToast = () => {
  const toast = useToast();
  const { isSignedIn } = useUser();

  return useStatusToast(toast, {
    defaultPosition: isSignedIn
      ? ToastPosition.BottomLeft
      : ToastPosition.Bottom,
  });
};
